import { buildServiceParamMap, enrichDataWithIncluded } from '@/common/utils'
import { RCHANS_URL, RRS_URL } from '@/common/constants'
import jwtInterceptor from '@/common/jwt-interceptor-wrapper'

const helpers = {
  async getCurrentChannels(rallyId) {
    const requestOptions = helpers.rallyChanelsParams(rallyId)
    const response = await jwtInterceptor(requestOptions)
    const currentChannels = response.data.data

    return currentChannels
  },

  async getCurrentRally(rallyId) {
    const requestOptions = helpers.singleRallyParams(rallyId)
    const response = await jwtInterceptor(requestOptions)
    const enrichedData = enrichDataWithIncluded(response)
    const currentRally = enrichedData[0]?.attributes
    currentRally.id = enrichedData[0]?.id

    return currentRally
  },

  getWrapper: (params, url) => {
    const tooMuchParamMapping = buildServiceParamMap(params)

    return {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
      url: url,
      params: Object.fromEntries(tooMuchParamMapping)
    }
  },

  rallyChanelsParams: (rallyId) => {
    const params = {
      default: true,
      rally_id: rallyId,
      sort: 'sort_order',
    }

    return helpers.getWrapper(params, RCHANS_URL())
  },

  singleRallyParams: (rallyId) => {
    const params = {
      id: rallyId,
      include: 'avatar,child_count,is_hub,member_count,my_membership,parent',
    }

    return helpers.getWrapper(params, RRS_URL() + '/rallies')
  },
}

const state = {
  currentRally: null,
  currentChannel: null,
  currentChannels: null,
}

const getters = {
  currentChannel: (state) => state.currentChannel,
  currentChannels: (state) => state.currentChannels,
  currentRally: (state) => state.currentRally,
}

const mutations = {
  setCurrentChannel: (state, payload) => {
    state.currentChannel = payload
  },
  setCurrentChannels: (state, payload) => {
    state.currentChannels = payload
  },
  setCurrentRally: (state, payload) => {
    state.currentRally = payload
  },
}

const actions = {
  clearCurrentRally({ commit, state }) {
    commit('setCurrentChannel', null)
    commit('setCurrentChannels', null)
    commit('setCurrentRally', null)
  },

  async fetchCurrentRallyData({ commit }, inparams ) {
    const { rallyId } = inparams
    const currentRally = await helpers.getCurrentRally(rallyId)
    const currentChannels = await helpers.getCurrentChannels(rallyId)

    commit('setCurrentRally', currentRally)
    commit('setCurrentChannels', currentChannels)
  },

  refreshCurrentRallyData({ commit, dispatch }) {
    const rallyId = state.currentRally?.id

    if ( rallyId ) {
      dispatch('fetchCurrentRallyData', { rallyId: state.currentRally.id })
    } else {
      console.error('currentRally not found')
    }
  },

  async setCurrentChannel({ commit }, inparams ) {
    const { route } = inparams

    let slug = route.params.channelSlug

    // This is only needed until Special Event slugs stop using ?fundraiser_type=.
    // Append ONLY that param — appending the whole query string (the old
    // behavior) made any link with extra params (?et=…&ut=… from emails, UTM
    // tags…) fail the slug match below, so currentChannel was never set and
    // the channel page rendered nav + rally header with an empty body.
    // Mirrors getChannelSlug() in common/utils.js.
    if ( route.query?.fundraiser_type ) slug = `${slug}?fundraiser_type=${route.query.fundraiser_type}`

    // Locate the current channel in the previously retrieved set of channels
    if ( !state.currentChannels ) { return }
    const channel = state.currentChannels.find(item => (item.attributes.slug.indexOf(slug) >= 0))

    // Set any helpers that we use in multiple other places
    if ( !channel ) { return }
    channel.isFirstChannel = ( state.currentChannels[0]?.id == channel?.id )

    commit('setCurrentChannel', channel)
  },
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
}
